const Token_Types = {
	REFRESH_TOKEN: "refresh_token",
	ACCESS_TOKEN: "access_token",
	userData: "user_data"
};

export { Token_Types };
